module.exports = __webpack_public_path__ + "assets/img/img-mv.d5ea5bd3.jpg";